import gql from 'graphql-tag';

export const GET_REGIONS_LANGUAGES = gql`
  query getRegionsLanguages {
    regions {
      id
      regionCode
      name
    }
    languages {
      id
      name
      languageCode
    }
  }
`;
